// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"5966373a","1860":"b78e8704","5585":"653ce6ae"}[chunkId] + ".chunk.css";
};